/* ============================================================
   THINKLY — GLOBAL THEME JAVASCRIPT
   thinkly-theme.js  |  Shopify Dawn asset
   ============================================================ */

(function () {
  'use strict';

  /* ─────────────────────────────────────────
     TOUCH DETECTION
  ───────────────────────────────────────── */
  const isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);


  /* ─────────────────────────────────────────
     CURSOR MARBLE
  ───────────────────────────────────────── */
  if (!isTouch) {
    const marble = document.getElementById('cursor-marble');
    const trail  = document.getElementById('cursor-trail');

    if (marble && trail) {
      let mx = 0, my = 0, tx = 0, ty = 0;

      document.addEventListener('mousemove', e => {
        mx = e.clientX;
        my = e.clientY;
        marble.style.left = (mx - 8) + 'px';
        marble.style.top  = (my - 8) + 'px';
      });

      function animateTrail() {
        tx += (mx - tx) * 0.12;
        ty += (my - ty) * 0.12;
        trail.style.left = tx + 'px';
        trail.style.top  = ty + 'px';
        requestAnimationFrame(animateTrail);
      }
      animateTrail();

      const interactiveSelector = [
        'a', 'button',
        '.kit', '.faq-item', '.b-card', '.rev',
        '.c-box', '.t-c-box', '.tcard-stack', '.tp-tcard-stack',
        '.soc', '.t-soc', '.fc', '.vc', '.ei'
      ].join(', ');

      document.querySelectorAll(interactiveSelector).forEach(el => {
        el.addEventListener('mouseenter', () => marble.classList.add('large'));
        el.addEventListener('mouseleave', () => marble.classList.remove('large'));
      });
    }
  }


  /* ─────────────────────────────────────────
     FIXED HEADER — collapse ann bar on scroll
     Ann bar hides after user scrolls past it.
     body.ann-gone reduces #MainContent padding.
  ───────────────────────────────────────── */
  (function () {
    const ann = document.querySelector('.t-ann');
    if (!ann) return;
    const annHeight = ann.offsetHeight;

    function onAnnScroll() {
      const past = window.scrollY > annHeight;
      ann.classList.toggle('ann-gone', past);
      document.body.classList.toggle('ann-gone', past);
    }

    window.addEventListener('scroll', onAnnScroll, { passive: true });
    onAnnScroll(); // run once on load in case page is already scrolled
  })();


  /* ─────────────────────────────────────────
     SCROLL REVEAL
  ───────────────────────────────────────── */
  const revealObs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) e.target.classList.add('visible');
    });
  }, { threshold: 0.06, rootMargin: '0px 0px -32px 0px' });

  function initReveal(root) {
    root.querySelectorAll('.reveal').forEach(el => {
      if (!el.classList.contains('visible')) revealObs.observe(el);
    });
  }

  initReveal(document);

  document.addEventListener('shopify:section:load', e => initReveal(e.target));


  /* ─────────────────────────────────────────
     HAMBURGER / NAV DRAWER
  ───────────────────────────────────────── */
  const hamburger  = document.getElementById('t-hamburger');
  const navOverlay = document.getElementById('t-nav-overlay');
  const navDrawer  = document.getElementById('t-nav-drawer');
  const navClose   = document.getElementById('t-nav-close');

  function openNav() {
    if (!hamburger || !navOverlay || !navDrawer) return;
    hamburger.classList.add('open');
    navOverlay.classList.add('open');
    navDrawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeNav() {
    if (!hamburger || !navOverlay || !navDrawer) return;
    hamburger.classList.remove('open');
    navOverlay.classList.remove('open');
    navDrawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (hamburger)  hamburger.addEventListener('click', openNav);
  if (navClose)   navClose.addEventListener('click', closeNav);
  if (navOverlay) navOverlay.addEventListener('click', closeNav);

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeNav();
  });


  /* ─────────────────────────────────────────
     HERO PARALLAX (desktop only)
  ───────────────────────────────────────── */
  if (!isTouch) {
    const heroMedia = document.querySelector(
      '.t-hero__media img, .t-hero__media video, .hero-img-wrap img, .hero-img-wrap video'
    );

    if (heroMedia) {
      heroMedia.style.willChange = 'transform';
      let ticking = false;

      function onParallaxScroll() {
        const scrollY = window.scrollY;
        const heroSection = heroMedia.closest('.hero, .t-hero');
        const heroBottom  = heroSection
          ? heroSection.offsetTop + heroSection.offsetHeight
          : 800;
        if (scrollY < heroBottom) {
          heroMedia.style.transform = `translateY(${scrollY * 0.4}px)`;
        }
      }

      window.addEventListener('scroll', () => {
        if (!ticking) {
          requestAnimationFrame(() => { onParallaxScroll(); ticking = false; });
          ticking = true;
        }
      }, { passive: true });

      onParallaxScroll();
    }
  }


  /* ─────────────────────────────────────────
     FAQ ACCORDION
     Handles both homepage (.t-faq-item) and
     product page (.tp-faq-item) accordions
  ───────────────────────────────────────── */
  window.toggleFaq = function (el) {
    // handles .faq-item (old HTML), .t-faq-item (homepage section), .tp-faq-item (product page)
    const isOpen = el.classList.contains('open');
    // Close all open items in the same FAQ container
    const container = el.closest('.faq, .faq-wrap, .t-faq, .tp-faq');
    if (container) {
      container.querySelectorAll('.faq-item.open, .t-faq-item.open, .tp-faq-item.open')
        .forEach(item => item.classList.remove('open'));
    }
    if (!isOpen) el.classList.add('open');
  };

  document.addEventListener('click', e => {
    const item = e.target.closest('.faq-item, .t-faq-item, .tp-faq-item');
    if (item) window.toggleFaq(item);
  });


  /* ─────────────────────────────────────────
     MOBILE TAP INTERACTIONS
     Handles both old (.c-box) and new (.t-c-box)
     flip card class names
  ───────────────────────────────────────── */
  if (isTouch) {
    // Flip cards
    document.querySelectorAll('.c-box, .t-c-box').forEach(box => {
      box.addEventListener('click', () => {
        document.querySelectorAll('.c-box.tapped, .t-c-box.tapped').forEach(b => {
          if (b !== box) b.classList.remove('tapped');
        });
        box.classList.toggle('tapped');
      });
    });

    // Close flip cards when tapping outside
    document.addEventListener('click', e => {
      if (!e.target.closest('.c-box, .t-c-box')) {
        document.querySelectorAll('.c-box.tapped, .t-c-box.tapped')
          .forEach(b => b.classList.remove('tapped'));
      }
      if (!e.target.closest('.tcard-stack, .t-tcard-stack, .tp-tcard-stack')) {
        document.querySelectorAll('.tcard-stack.tapped, .t-tcard-stack.tapped, .tp-tcard-stack.tapped')
          .forEach(t => t.classList.remove('tapped'));
      }
    });

    // Think card peel — homepage section
    const tstack = document.querySelector('.tcard-stack, .t-tcard-stack');
    if (tstack) {
      tstack.addEventListener('click', () => tstack.classList.toggle('tapped'));
    }
  }


  /* ─────────────────────────────────────────
     REVIEWS CAROUSEL — homepage section
     Handles .t-rev-grid / .t-rev-arrow (new sections)
     and .rev-grid / .rev-arrow (legacy HTML)
  ───────────────────────────────────────── */

  // New section classes (thinkly-reviews.liquid)
  (function () {
    const grid = document.querySelector('.t-rev-grid');
    const prev = document.querySelector('.t-rev-arrow.prev');
    const next = document.querySelector('.t-rev-arrow.next');
    if (!grid || !prev || !next) return;

    function cardWidth() {
      const card = grid.querySelector('.t-rev');
      if (!card) return 400;
      const gap = parseInt(window.getComputedStyle(grid).gap || '24');
      return card.offsetWidth + gap;
    }

    prev.addEventListener('click', () => grid.scrollBy({ left: -cardWidth(), behavior: 'smooth' }));
    next.addEventListener('click', () => grid.scrollBy({ left:  cardWidth(), behavior: 'smooth' }));
  })();

  // Legacy classes (old HTML pages) — infinite scroll with clones
  function initReviewsCarousel() {
    const rGrid  = document.querySelector('.rev-grid');
    const pArrow = document.querySelector('.rev-arrow.prev');
    const nArrow = document.querySelector('.rev-arrow.next');
    if (!rGrid || !pArrow || !nArrow) return;

    const cards = Array.from(rGrid.querySelectorAll('.rev:not(.clone)'));
    const numOriginals = cards.length;
    if (numOriginals === 0) return;

    for (let i = 0; i < numOriginals; i++) {
      const clone = cards[i].cloneNode(true);
      clone.classList.add('clone', 'visible');
      rGrid.appendChild(clone);
    }

    const firstOriginal = cards[0];
    for (let i = 0; i < numOriginals; i++) {
      const clone = cards[i].cloneNode(true);
      clone.classList.add('clone', 'visible');
      rGrid.insertBefore(clone, firstOriginal);
    }

    function getCardWidth() {
      const firstCard = rGrid.querySelector('.rev');
      const gap = parseInt(window.getComputedStyle(rGrid).gap || '24');
      return firstCard.offsetWidth + gap;
    }

    function initScroll() {
      rGrid.style.scrollBehavior = 'auto';
      rGrid.scrollLeft = numOriginals * getCardWidth();
      rGrid.offsetHeight;
      rGrid.style.scrollBehavior = 'smooth';
    }

    window.addEventListener('load',   initScroll);
    window.addEventListener('resize', initScroll);
    requestAnimationFrame(initScroll);

    rGrid.addEventListener('scroll', () => {
      const scrollLeft = rGrid.scrollLeft;
      const cardWidth  = getCardWidth();
      if (scrollLeft <= (numOriginals - 1) * cardWidth + 10) {
        rGrid.style.scrollBehavior = 'auto';
        rGrid.scrollLeft += numOriginals * cardWidth;
        rGrid.offsetHeight;
        rGrid.style.scrollBehavior = 'smooth';
      } else if (scrollLeft >= (2 * numOriginals) * cardWidth - 10) {
        rGrid.style.scrollBehavior = 'auto';
        rGrid.scrollLeft -= numOriginals * cardWidth;
        rGrid.offsetHeight;
        rGrid.style.scrollBehavior = 'smooth';
      }
    });

    nArrow.addEventListener('click', () => rGrid.scrollBy({ left:  getCardWidth(), behavior: 'smooth' }));
    pArrow.addEventListener('click', () => rGrid.scrollBy({ left: -getCardWidth(), behavior: 'smooth' }));
  }

  initReviewsCarousel();


  /* ─────────────────────────────────────────
     ACTIVE NAV LINK
  ───────────────────────────────────────── */
  (function setActiveNav() {
    const path = window.location.pathname;

    const navMap = [
      { match: /^\/$|^\/index/,               href: '/' },
      { match: /^\/pages\/about/,             href: '/pages/about' },
      { match: /^\/pages\/build-ideas/,       href: '/pages/build-ideas' },
      { match: /^\/pages\/science-of-play/,   href: '/pages/science-of-play' },
      { match: /^\/pages\/gifting/,           href: '/pages/gifting' },
      { match: /^\/pages\/contact/,           href: '/pages/contact' },
      { match: /^\/pages\/faq/,               href: '/pages/faq' },
      { match: /^\/collections|^\/products/,  href: '/collections/thinkly-flow-kits' },
    ];

    document.querySelectorAll('.t-header__nav a, .t-nav-links a').forEach(link => {
      link.classList.remove('active');
      const linkPath = new URL(link.href, window.location.origin).pathname;
      navMap.forEach(rule => {
        if (rule.match.test(path) && linkPath === rule.href) {
          link.classList.add('active');
        }
      });
    });
  })();

})();


/* ============================================================
   THINKLY CART — header icon, dropdown, AJAX add-to-cart, toast
   Reuses existing .t-header__cart / .t-cart-badge / .t-toast
   classes already defined in thinkly-theme.css.
   ============================================================ */
window.ThinklyCart = (function () {
  'use strict';

  var dropdown, badge, itemsWrap, subtotalEl, footer, cartBtn;
  var isOpen = false;
  var toastTimeout = null;

  function qs(id) { return document.getElementById(id); }

  function formatMoney(cents) {
    var amount = (cents || 0) / 100;
    return '₹' + amount.toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : str;
    return div.innerHTML;
  }

  function init() {
    dropdown   = qs('t-cart-dropdown');
    badge      = qs('t-cart-badge');
    itemsWrap  = qs('t-cart-items');
    subtotalEl = qs('t-cart-subtotal');
    footer     = qs('t-cart-footer');
    cartBtn    = qs('t-cart-btn');

    if (cartBtn) {
      cartBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        toggleDropdown();
      });
    }

    document.addEventListener('click', function (e) {
      if (isOpen && dropdown && !dropdown.contains(e.target) && e.target !== cartBtn) {
        closeDropdown();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDropdown();
    });

    refresh();
  }

  function toggleDropdown() { isOpen ? closeDropdown() : openDropdown(); }

  function openDropdown() {
    if (!dropdown) return;
    refresh();
    dropdown.classList.add('open');
    isOpen = true;
  }

  function closeDropdown() {
    if (!dropdown) return;
    dropdown.classList.remove('open');
    isOpen = false;
  }

  function refresh() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        return cart;
      })
      .catch(function (err) { console.error('Thinkly cart refresh failed', err); });
  }

  function renderCart(cart) {
    if (badge) {
      var newCount = cart.item_count;
      if (badge.textContent !== String(newCount)) {
        badge.textContent = newCount;
        badge.classList.add('pop');
        setTimeout(function () { badge.classList.remove('pop'); }, 300);
      }
    }
    if (!itemsWrap) return;

    if (!cart.items || cart.items.length === 0) {
      itemsWrap.innerHTML = '<div class="t-cart__empty">Your cart is empty.<br><a href="/products/thinkly-flow-master">Explore Thinkly Flow</a></div>';
      if (subtotalEl) subtotalEl.textContent = formatMoney(0);
      if (footer) footer.classList.add('t-cart__footer--empty');
      return;
    }

    if (footer) footer.classList.remove('t-cart__footer--empty');

    var html = '';
    cart.items.forEach(function (item) {
      html +=
        '<div class="t-cart__item">' +
          '<div class="t-cart__item-img">' +
            (item.image ? '<img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '" width="56" height="56">' : '') +
          '</div>' +
          '<div class="t-cart__item-body">' +
            '<div class="t-cart__item-name">' + escapeHtml(item.product_title) + '</div>' +
            (item.variant_title ? '<div class="t-cart__item-variant">' + escapeHtml(item.variant_title) + '</div>' : '') +
            '<div class="t-cart__item-row">' +
              '<div class="t-cart__qty">' +
                '<button type="button" class="t-cart__qty-btn" data-action="dec" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Decrease quantity">' + '\u2212' + '</button>' +
                '<span class="t-cart__qty-val">' + item.quantity + '</span>' +
                '<button type="button" class="t-cart__qty-btn" data-action="inc" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<div class="t-cart__item-price">' + formatMoney(item.final_line_price) + '</div>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="t-cart__item-remove" data-action="remove" data-key="' + item.key + '" aria-label="Remove item">' + '\u2715' + '</button>' +
        '</div>';
    });
    itemsWrap.innerHTML = html;

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    itemsWrap.querySelectorAll('[data-action]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.key;
        var action = btn.dataset.action;
        var qty = parseInt(btn.dataset.qty || '1', 10);
        if (action === 'remove') changeLine(key, 0);
        else if (action === 'inc') changeLine(key, qty + 1);
        else if (action === 'dec') changeLine(key, Math.max(0, qty - 1));
      });
    });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function (err) { console.error('Thinkly cart change failed', err); });
  }

  function addItems(items, opts) {
    opts = opts || {};
    var payload = items.length === 1
      ? { id: items[0].id, quantity: items[0].quantity || 1 }
      : { items: items };

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () {
        return refresh().then(function (cart) {
          if (opts.toastMessage) showToast(opts.toastMessage);
          return cart;
        });
      });
  }

  function ensureToastEl() {
    var t = qs('t-cart-toast-el');
    if (t) return t;
    t = document.createElement('div');
    t.id = 't-cart-toast-el';
    t.className = 't-toast';
    t.innerHTML =
      '<span class="t-toast__icon">🛍️</span>' +
      '<span class="t-toast__msg" id="t-cart-toast-msg"></span>';
    document.body.appendChild(t);
    return t;
  }

  function showToast(message) {
    var toast = ensureToastEl();
    var msgEl = qs('t-cart-toast-msg');
    if (msgEl) msgEl.textContent = message;
    toast.classList.add('visible');
    if (toastTimeout) clearTimeout(toastTimeout);
    toastTimeout = setTimeout(function () {
      toast.classList.remove('visible');
    }, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  return {
    addItems: addItems,
    refresh: refresh,
    showToast: showToast,
    openDropdown: openDropdown,
    closeDropdown: closeDropdown
  };
})();
